import { render, staticRenderFns } from "./BookingTransfer.vue?vue&type=template&id=e6ab1ade"
import script from "./BookingTransfer.vue?vue&type=script&lang=js"
export * from "./BookingTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports